// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import GlobalAlertGate from './components/GlobalAlertGate'; // ✅ global maintenance/down banner

import LandingPage from './components/LandingPage';
import LoginPage from './components/LoginPage';
import CreateAccount from './components/CreateAccount';
import UploadPage from './components/UploadPage';
import Team_Details from './components/Team_Details';
import WelcomePage from './components/WelcomePage';
import DashboardPage from './components/DashboardPage';
import FeedbackPage from './components/FeedbackPage';
import NewsRoom from './components/NewsRoom';
import InterviewPage from './components/InterviewPage';
import LLMPage from './components/LLMPage'; // 👈 fixed path

function App() {
  return (
    <Router>
      {/* Renders across ALL pages */}
      <GlobalAlertGate />

      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/create-account" element={<CreateAccount />} />
        <Route path="/upload" element={<UploadPage />} />
        <Route path="/team" element={<Team_Details />} />
        <Route path="/welcome" element={<WelcomePage />} />
        <Route path="/statistics" element={<DashboardPage />} />
        <Route path="/feedback" element={<FeedbackPage />} />
        <Route path="/newsroom" element={<NewsRoom />} />
        <Route path="/interview" element={<InterviewPage />} />
        <Route path="/vlm" element={<LLMPage />} /> {/* VLMs -> LLMPage */}
      </Routes>
    </Router>
  );
}

export default App;
